<template>
  <span>
    <div class="boss-scout-send-container">
      <dl class="boss-scout-send-wrap cleafix">
        <dt class="boss-scout-send-left">
          テンプレート
          <span
            v-tooltip="{ content: 'メッセージテンプレートの作成・編集は、「各種設定」メニューで行えます。'}"
            class="pega-circle"
          >?</span>
        </dt>
        <dd class="boss-scout-send-right">
          <select
            :value="selectedTemplateId"
            class="boss-input-select"
            @change="setSelectedTemplateMessage($event.target.value, selectedTemplateId)"
          >
            <option
              :value="null"
              data-test="template-option-none"
            >
              指定なし
            </option>
            <option
              v-for="(template, i) in templates"
              :key="i"
              :data-test="'template-option-' + i"
              :value="template.id"
            >{{ template.name }}
            </option>
          </select>
        </dd>
        <dt class="boss-scout-send-left">件名</dt>
        <dd class="boss-scout-send-right">
          <input
            :value="subject"
            :class="{ 'is-invalid-input': hasTemplateReplacementCharacters(subject) }"
            class="boss-send-subject"
            type="text"
            data-test="message-subject"
            @input="$emit('update:subject', $event.target.value)"
          >
          <span
            v-if="hasTemplateReplacementCharacters(subject)"
            class="form-error is-visible margin-0"
            data-test="has-template-replacement-characters-subject"
          >「●●【」または「】●●」が入力フォームに残っていると、送信することができません</span>
        </dd>
        <dt class="boss-scout-send-left">本文</dt>
        <dd class="boss-scout-send-right">
          <div class="boss-textarea-button">
            <button
              v-tooltip="{ content: '本文にカーソルを合わせてクリックすると、■USER_ID■ 様 と挿入されます。メッセージ送信時に自動的に会員IDに変換されます。'}"
              class="boss-button"
              type="button"
              data-test="insertion-user-id"
              @click="insertionValue('■USER_ID■ 様')"
            >会員IDを挿入</button>
            <button
              v-tooltip="{ content: '本文にカーソルを合わせてクリックすると、社名が挿入されます。'}"
              class="boss-button"
              type="button"
              data-test="insertion-company-name"
              @click="insertionValue(currentUser.companyName)"
            >社名を挿入</button><span style="font-size: .8125rem;">（本文にのみ有効）</span>
          </div>
          <textarea
            ref="message"
            :value="body"
            :class="{ 'is-invalid-input': hasTemplateReplacementCharacters(body)}"
            data-test="message-body"
            class="boss-send-textarea"
            rows
            cols
            @input="$emit('update:body', $event.target.value)"
          />
          <span
            v-if="hasTemplateReplacementCharacters(body)"
            class="form-error is-visible margin-0"
            data-test="has-template-replacement-characters-body"
          >「●●【」または「】●●」が入力フォームに残っていると、送信することができません</span>
        </dd>
        <dt class="boss-scout-send-left">スカウト特典（任意）</dt>
        <dd class="boss-scout-send-right boss-bonus-container">
          <!-- v-forだと改行されないためスタイルで対応 -->
          <label
            v-for="(specialFavor, i) in specialFavors"
            :key="i"
            v-tooltip="{ content: specialFavor.description}"
            class="boss-scout-bonus pega-mr-5 pega-input"
          ><input
            :checked="specialFavorIds.includes(specialFavor.id)"
            :value="specialFavor.id"
            :data-test="'special-favor-' + specialFavor.id"
            class="boss-bonus-check"
            type="checkbox"
            @change="onSpecialFavorChange"
            @click="clearAccepted"
          ><span class="boss-bonus-check-text boss-bonus-check-mark">{{ specialFavor.name }}</span>
          </label>
        </dd>
        <dt class="boss-scout-send-left">送信日時</dt>
        <dd class="boss-scout-send-right">
          <div>
            <label
              v-if="!reservationId"
              class="pega-input display-inline-block"
            >
              <input
                :checked="isImmediately === true"
                :value="true"
                class="boss-sent-radio"
                type="radio"
                data-test="immediately"
                @change="onImmediately(true)"
              >
              <span class="boss-sent-radio-text">即時送信</span>
            </label>
            <div v-if="isScoutedForTransition">
              <label
                class="display-inline boss-annotation-text"
                data-test="scout-annotation-text"
              >※スカウト配信は1名につき1日1通までです。本日配信済みの会員は送信時に除外されます。</label>
            </div>
          </div>
          <div class="boss-sent-date">
            <label class="pega-input display-inline-block">
              <input
                :checked="isImmediately === false"
                :value="false"
                class="boss-sent-radio"
                type="radio"
                data-test="send-reservation"
                @change="onImmediately(false)"
              >
              <span
                class="boss-sent-radio-text margin-right-1"
              >送信日時の指定</span>
              <input
                :value="reservationName"
                class="boss-send-subject width-25 display-inline"
                placeholder="スカウト送信予約名"
                type="text"
                data-test="message-reservation-name"
                @focusin="onImmediately(false)"
                @input="$emit('update:reservationName', $event.target.value)"
              >
              <date-picker
                :value="sendDate"
                type="date"
                :disabled-date="notTodayBetweenScoutEndDate"
                input-class="pega-picker"
                :style="{ width: 'auto' }"
                placeholder="日付を選択"
                :editable="false"
                value-type="YYYY-MM-DD"
                @change="onUpdateDate"
              />
              <date-picker
                :value="sendTime"
                :minute-step="30"
                :disabled-time="disabledTime"
                :default-value="defaultValueInDaytime"
                type="time"
                popup-class="pega-custom-time-header pega-disable-to-none"
                placeholder="時間を選択"
                format="HH:mm"
                input-class="pega-picker"
                :style="{ width: 'auto' }"
                :editable="false"
                value-type="HH:mm"
                @change="onUpdateTime"
              />
            </label>
            <div>
              <label
                class="display-inline boss-annotation-text"
                data-test="remind-sent"
              >※予約できる時間は7:00～21:00までです。</label>
            </div>
          </div>
        </dd>
      </dl>
    </div>
    <div
      v-if="specialFavorIds.length > 0"
      class="grid-x grid-margin-x grid-padding-y grid-padding-x margin-top-2 margin-bottom-1  align-center"
    >
      <div class="cell medium-7 special-favor-flame">
        <div class="information"><div>i</div></div>
        <div class="grid-x margin-top-1 margin-left-3">
          <input
            id="check"
            v-model="accepted"
            type="checkbox"
            class="special-favor-notice-check"
            data-test="special-favor-warning-checkbox"
          >
          <label
            class="special-favor-notice"
            for="check"
          />
          <label
            class="boss-color-red special-favor-notice-label"
            for="check"
          >
            以下のスカウト特典が設定されています。応募があった際は必ずご対応ください。
          </label>
        </div>
        <div class="grid-x grid-margin-x align-center margin-top-1">
          <div class="cell medium-8">
            <div
              v-for="checkedSpecialFavor in checkedSpecialFavors"
              :key="checkedSpecialFavor.id"
              class="grid-x grid-margin-x"
            >
              <li :data-test="'special-favor-warning-label-' + checkedSpecialFavor.id">
                {{ checkedSpecialFavor.name }}：{{ checkedSpecialFavor.description }}
              </li>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="boss-layout boss-layout-center margin-top-2">
      <button
        class="boss-button boss-button-return"
        data-test="history-back"
        @click="$router.back()"
      >
        <span class="boss-button-return-text">戻る</span>
      </button>
      <button
        :disabled="isConfirmButtonDisabled"
        type="button"
        class="boss-button boss-button-confirm pega-button"
        data-test="sent-confirmation"
        @click="$emit('showDetail')"
      >
        <span class="boss-button-confirm-text">送信内容を確認する</span>
      </button>
    </div>
  </span>
</template>

<style scoped>
.special-favor-flame {
  border: 1px solid #a2adb3;
  border-radius: 16px;
  position: relative;
}

.information {
  background-color: white;
  padding: 0 15px 0 15px;
  position: absolute;
  top: 0;
  left: 0;
  transform: translateY(-50%) translateX(1em);
}

.information > div {
  color: #419cd9;
  border: solid 1px #419cd9;
  border-radius: 50%;
  width: 1.4em;
  height: 1.4em;
  display: inline-block;
  text-align: center;
  line-height: 1.3em;
  font-size: 1.2em;
}

.special-favor-notice-label {
  font-weight: bold;
  cursor: pointer;
}
</style>

<script>
import { mapActions, mapGetters } from 'vuex'
import _ from 'lodash'
import DatePicker from 'vue2-datepicker'
import datePickerFunction from '@/lib/datePickerFunction.js'
import { now, createDate } from '@/lib/dateUtils.js'

export default {
  components: {
    DatePicker
  },
  mixins: [datePickerFunction],
  props: {
    subject: {
      type: String,
      required: true
    },
    body: {
      type: String,
      required: true
    },
    specialFavorIds: {
      type: Array,
      required: true
    },
    sendDate: {
      type: String,
      default: null
    },
    sendTime: {
      type: String,
      default: null
    },
    reservationName: {
      type: String,
      default: ''
    },
    isImmediately: {
      type: Boolean,
      required: true
    },
    checkedUserIds: {
      type: Array,
      required: true
    },
    scoutEndDate: {
      type: String,
      default: null
    },
    reservationId: {
      type: Number,
      default: null
    },
    isScoutedForTransition: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      templates: [],
      selectedTemplateId: null,
      accepted: false
    }
  },
  computed: {
    hasTemplateReplacementCharacters () {
      return (val) => {
        return /●●【|】●●/.test(val)
      }
    },
    isEmptySubject () {
      return this.subject.trim().length === 0
    },
    isEmptyBody () {
      return this.body.trim().length === 0
    },
    isAccepted () {
      return this.specialFavorIds.length === 0 || (this.specialFavorIds.length > 0 && this.accepted)
    },
    isConfirmButtonDisabled () {
      return this.isEmptySubject ||
        this.isEmptyBody ||
        this.hasTemplateReplacementCharacters(this.subject) ||
        this.hasTemplateReplacementCharacters(this.body) ||
        !this.isAccepted ||
        _.isEmpty(this.checkedUserIds) ||
        this.isReservationValidation || this.checkedUserIds.length > 2000
    },
    isReservationValidation () {
      return !this.isImmediately && (!this.sendDate ||
        !this.sendTime ||
        !this.reservationName ||
        this.hasTemplateReplacementCharacters(this.reservationName))
    },
    checkedSpecialFavors () {
      return _.filter(this.specialFavors, specialFavor =>
        _.some(this.specialFavorIds, specialFavorId =>
          specialFavorId === specialFavor.id
        )
      )
    },
    disabledTime () {
      if (createDate(this.sendDate)?.isSame(now(), 'day')) {
        return this.isNowBeforeTime
      } else {
        return this.notNightReservationTime
      }
    },
    ...mapGetters({
      specialFavors: 'specialFavorsMaster',
      currentUser: 'currentUser'
    })
  },
  created () {
    this.storeMaster('specialFavors')
    this.fetchTemplates()
  },
  methods: {
    ...mapActions([
      'storeMaster'
    ]),
    insertionValue (value) {
      const cursorPosition = this.$refs.message.selectionStart
      this.$emit('update:body', this.body.substr(0, cursorPosition) + value + this.body.substr(cursorPosition, this.body.length))
    },
    fetchTemplates () {
      this.$http.secured.get('/company/scout/message/templates/_display').then(response => {
        this.$set(this, 'templates', response.data)
      })
    },
    fetchTemplate () {
      this.$http.secured.get(`/company/scout/message/templates/${this.selectedTemplateId}`).then(response => {
        const template = response.data
        this.$emit('update:body', template.body)
        this.$emit('update:subject', template.subject)
        this.$emit('update:specialFavorIds', template.specialFavorIds)
      })
    },
    setSelectedTemplateMessage (newId, oldId) {
      if (!newId) {
        // 「指定なし」が選択された場合は、selectedTemplateIdのみ更新
        this.$set(this, 'selectedTemplateId', null)
        return
      }

      if (!this.subject && !this.body && !this.specialFavorIds.length) {
        // 件名・本文・スカウト特典が未入力の場合にテンプレートが変更された場合は、テンプレートを反映
        this.$set(this, 'selectedTemplateId', newId)
        this.fetchTemplate()
        return
      }

      // 件名 または 本文 または スカウト特典が入力済みの場合にテンプレートが変更された場合は、確認ダイアログを出す
      this.$dialog.confirm('現在入力している件名・本文・スカウト特典が削除されます。テンプレートを適応してよろしいですか？')
        // はいを押下した時：テンプレートを反映
        .then(() => {
          this.$set(this, 'selectedTemplateId', newId)
          this.fetchTemplate()
        })
        // いいえを押下した時：選択前の値に戻す
        .catch(() => {
          // 一度空更新しないと、同一の値とみなされてselectに反映されないため、空更新してからoldIdを連携
          this.$set(this, 'selectedTemplateId', '')
          this.$set(this, 'selectedTemplateId', oldId)
        })
    },
    clearAccepted () {
      if (this.specialFavorIds.length === 0) {
        this.accepted = false
      }
    },
    onSpecialFavorChange ($event) {
      if ($event.target.checked) {
        this.$emit('update:specialFavorIds', [...this.specialFavorIds, $event.target._value])
      } else {
        this.$emit('update:specialFavorIds', _.without(this.specialFavorIds, $event.target._value))
      }
    },
    onImmediately (val) {
      this.$emit('update:isImmediately', val)
    },
    onUpdateDate (val) {
      this.$emit('update:sendDate', val)
    },
    onUpdateTime (val) {
      this.$emit('update:sendTime', val)
    },
    notTodayBetweenScoutEndDate (date) {
      const baseDate = createDate(date)
      return baseDate?.isBefore(now(), 'day') || createDate(this.scoutEndDate)?.isBefore(baseDate)
    },
    isNowBeforeTime (date) {
      return createDate(date)?.isBefore(now().add(30, 'minutes'), 'minutes') ||
        // 現在時刻と時間が一緒の場合
        createDate(date)?.hour() === now().hour() ||
        this.notNightReservationTime(date)
    }
  }
}
</script>
